import { createSlice } from '@reduxjs/toolkit'
import { AffiliateType } from '../../models/affiliate.interface'

export interface AffiliateState {
  balanceOfStaking: string
  link: string
  isLoginAff: boolean
  isStaking: boolean
  info: AffiliateType | null
  address: string
  commission: string | '0'
  isApprovedToken: string
}

const initialState: AffiliateState = {
  balanceOfStaking: '0',
  link: '',
  isLoginAff: false,
  isStaking: false,
  isApprovedToken: 'none',
  info: null,
  commission: '0',
  address: '',
}

export const affiliateSlice = createSlice({
  name: 'affiliate',
  initialState,
  reducers: {
    setBalanceOfStaking: (state, action) => {
      state.balanceOfStaking = action.payload
    },
    setStateKey: (state: any, action) => {
      const { key, value } = action.payload
      state[key] = value
    },
    authAff: (state) => {}, //  saga
    fetchAffLink: (state) => {}, // saga
    fetchAffInfo: (state) => {}, // saga
    fetchAffiliateAddress: (state) => {}, //  saga
    createViewAffiliate: (state) => {}, //  saga
    updateTx: (state) => {},
  },
}) //  end slice

export const {
  fetchAffLink,
  setStateKey,
  authAff,
  fetchAffInfo,
  fetchAffiliateAddress,
  createViewAffiliate,
  updateTx
} = affiliateSlice.actions
export const { name, actions, reducer } = affiliateSlice
export default affiliateSlice.reducer
